<app-cookie-banner-display [cookieUrl]="cookieUrl">
</app-cookie-banner-display>
<app-header></app-header>
<main>
  <div class="main">
    <router-outlet></router-outlet>
  </div>
</main>
<app-footer></app-footer>
